
import HrBill from '@/models/operator/hr-bill'
import PaginationTpl from "components/base/PaginationTpl";
import statusMixins from '@/common/mixins/status.js'
import workTypeMixins from "@/common/mixins/work-type";
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob } from "common/js/util";
const STATUS = { 1: '待核实', 2: '已核实' }
export default {
  mixins: [statusMixins, workTypeMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      menuList: [
        { name: '日账单', url: '/operate/dues/hrBill/hrDateBill' },
        { name: '月账单', url: '/operate/dues/hrBill/hrMonthBill' },
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        { label: '日期', prop: 'billDate', width: '', alignment: 'left' },
        { label: '劳务公司名称', prop: 'companyName', width: '', alignment: 'left' },
        { label: '工时', prop: 'times', width: '', alignment: 'right' },
        { label: '人数', prop: 'peopleNums', width: '', alignment: 'right' },
        { label: '金额', prop: 'amount', width: '', alignment: 'right' },
        { label: '账单状态', prop: 'statusVal', width: '', alignment: 'left' }
      ],

      drawer: false,
      paymentBillFeeDetailId: null,
      baseInfoForm: {
        billDate: '',
        status: '',
        companyName: '',
        statusVal: null,
        totalPeople: 0,
        totalTimes: 0,
        totalAmount: 0,
      },
      // 账单录列表
      billList: [],
      billTitleList: [
        { label: "员工名称", prop: "name", width: "", alignment: 'left' },
        { label: "工种", prop: "typeVal", width: "", alignment: 'left' },
        { label: "上班时间", prop: "workShift", width: "154", alignment: 'left' },
        { label: "下班时间", prop: "closingTime", width: "154", alignment: 'left' },
        { label: "奖惩", prop: "rewardsAndPunishments", width: "", alignment: 'right' },
        { label: "当日工费", prop: "laborCostOfTheDay", width: "", alignment: 'right' },
        { label: "实际支出", prop: "actualExpenditure", width: "", alignment: 'right' },
        { label: "备注", prop: "remarks", width: "", alignment: 'left' },
      ],
    }
  },

  created() {
  },

  methods: {
    /**
     * @desc 账单列表
     */
    initHrBillList() {
      let pageNo = this.currentPage
      let type = this.search.select
      let reportDate
      if (type === 1) {
        reportDate = this.search.date ? this.search.date : ''
      } else {
        reportDate = this.search.month ? this.search.month : ''
      }
      let data = {
        type,
        reportDate,
        pageNo
      }
      HrBill.getHrBillList(data).then(res => {
        if (res.success) {
          let { totalNum, pageSize, items } = res.result
          this.total = totalNum
          this.pageSize = pageSize
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.paymentBillFeeDetailId
            obj.companyName = i.companyName
            obj.times = i.workHour
            obj.billDate = i.reportDate
            obj.peopleNums = i.peopleNum
            obj.status = i.status
            obj.statusVal = STATUS[i.status];
            obj.amount = i.totalCost ? numsToRMBSymbolAndMillimeter(i.totalCost) : numsToRMBSymbolAndMillimeter(0);
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },


    /**
     * @desc 获取账单详情数据
     */
    initBillDetails() {
      let paymentBillFeeDetailId = this.paymentBillFeeDetailId
      let data = {
        paymentBillFeeDetailId
      }
      HrBill.getDetails(data).then((res) => {
        if (res.success) {
          let {
            reportDate,
            companyName,
            status,
            peopleNum,
            totalCost,
            workHour,
          } = res.result;

          this.baseInfoForm.billDate = reportDate;
          this.baseInfoForm.companyName = companyName;
          this.baseInfoForm.totalPeople = peopleNum;
          this.baseInfoForm.status = status;
          this.baseInfoForm.statusVal = STATUS[status];
          this.baseInfoForm.totalTimes = workHour;
          this.baseInfoForm.totalAmount = numsToRMBSymbolAndMillimeter(totalCost);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 员工薪资列表
    */
    initSalaryList() {
      let paymentBillFeeDetailId = this.paymentBillFeeDetailId
      let data = {
        paymentBillFeeDetailId
      }
      HrBill.getSalaryList(data).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map(i => {
            let obj = {}
            obj.name = i.name
            obj.type = i.type
            obj.typeVal = this.workTypeObj[i.type]
            obj.workShift = i.startTime
            obj.closingTime = i.endTime
            obj.remarks = i.remarks
            obj.rewardsAndPunishments = numsToRMBSymbolAndMillimeter(i.rewardPunishment);
            obj.laborCostOfTheDay = numsToRMBSymbolAndMillimeter(i.laborSalary);
            obj.actualExpenditure = numsToRMBSymbolAndMillimeter(i.laborCost);
            arr.push(obj)
          })
          this.billList = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    initDetailsInfo() {
      this.initBillDetails()
      this.initSalaryList()
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    searchList() {
      this.currentPage = 1
      this.initHrBillList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search.date = ''
      this.search.month = ''
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 1 && columnIndex < 5) {
        return 'right-align'
      }
    },

    headerRecordsCellClassName({ columnIndex }) {
      if (columnIndex > 3 && columnIndex < 7) {
        return 'right-align'
      }
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initHrBillList()
    },

    openDetails(row) {
      this.paymentBillFeeDetailId = row.id
      this.initDetailsInfo()
      this.drawer = true
    },

    handleCloseDrawer() {
      this.drawer = false
    },

    /**
     * @desc 核实账单
     */
    batchVerification() {
      this.$confirm("核实后，该账单将不可再次修改，请确认", "核实", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-blue",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          paymentBillFeeDetailId: this.paymentBillFeeDetailId
        }
        HrBill.postVerify(data).then(res => {
          if (res.success) {
            this.initDetailsInfo()
            this.initHrBillList()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    /**
     * @desc 导出账单
     */
    exportExcel() {
      let paymentBillFeeDetailId = this.paymentBillFeeDetailId
      let reportDate = this.baseInfoForm.billDate
      let data = {
        reportDate,
        paymentBillFeeDetailId
      }
      HrBill.getExport(data).then((res) => {
        downLoadFileByBlob(res)
      });
    },
  }
}